/* eslint-disable */
import React from 'react';
import { AccordionSection, LayerItem } from 'mapcontrols/components/subComponents';
import { REFERENCE_LAYERS_LIST_OBJ } from 'mapcontrols/constants';

const ReferenceLayersSection = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  activeLayerIds = [],
  onLayerToggle = () => {},
  mapLegendImages = [],
}) => {
  return (
    <AccordionSection
      title="Reference Layers"
      id="reference"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {REFERENCE_LAYERS_LIST_OBJ.map(({ id, label, image }) => {
        return (
          <LayerItem
            key={id}
            layerId={id}
            label={label}
            swatchStyle={{ backgroundImage: `url(${mapLegendImages[image] || ''})` }}
            swatchType="image"
            hasLabels={true}
            stackingOrder="320"
            isActive={activeLayerIds.includes(id)}
            isLabelsActive={activeLayerIds.includes(`${id}-labels`)}
            onToggle={onLayerToggle}
            onLabelsToggle={onLayerToggle}
          />
        );
      })}
    </AccordionSection>
  );
};

export default ReferenceLayersSection;
